export function isHtmlEmpty(content: string | null | undefined): boolean {
  if (!content) return true;
  return content.replace(/<(?:.|\n)*?>/gm, '').trim().length === 0;
}

export function isDateValid(date: any): boolean {
  if (!date) {
    return false;
  }
  return !isNaN(new Date(date).getTime());
}


// WEBPACK FOOTER //
// ./src/app/utils/html.utils.ts